var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAuthApple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verify-your-Account",
    transform: "translate(-41.000000, -610.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "company",
    transform: "translate(14.000000, 11.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4317687,0 C14.0944598,0.0924985055 12.5313918,0.948501624 11.6205167,2.063187 C10.7895979,3.07439948 10.1060496,4.57632437 10.3725708,6.03591943 C11.8337336,6.0813848 13.3434973,5.20500065 14.2183137,4.07150201 C15.0366903,3.01639194 15.65596,1.52387368 15.4317687,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7167257,9.2824629 C19.432721,7.67236179 17.6282162,6.73797011 15.9240489,6.73797011 C13.6742971,6.73797011 12.7226599,7.81502898 11.1595919,7.81502898 C9.54792307,7.81502898 8.3234937,6.74110565 6.37788954,6.74110565 C4.46677635,6.74110565 2.43180923,7.90909526 1.14153346,9.90643587 C-0.672377908,12.7190175 -0.361959194,18.0071101 2.57761196,22.511317 C3.62958648,24.1229858 5.03430955,25.9353294 6.87173749,25.9511786 C8.50692294,25.9666849 8.96784769,24.9021682 11.1831085,24.8911938 C13.3983693,24.8786516 13.818532,25.9651171 15.4505819,25.9478716 C17.2895776,25.9337617 18.7711215,23.9254467 19.823096,22.3137778 C20.577194,21.1583303 20.8578251,20.5766872 21.4426038,19.2723015 C17.1892403,17.6527938 16.5072598,11.6043322 20.7167257,9.2824629 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthApple);
export default __webpack_public_path__ + "static/media/icAuthApple.e821b3e89388bdb50862ffdf2454548c.svg";
export { ForwardRef as ReactComponent };